import type React from 'react';

import { TagList } from '@xing-com/crate-jobs-domain-serps-components-tag-list';
import { useTopSubcategories } from '@xing-com/crate-jobs-domain-serps-hooks';

export const TopSubcategories: React.FC = () => {
  const { roles } = useTopSubcategories();

  return (
    <TagList headerCopyKey="XJM_TEASER_LINKS_TERM_TITLE" serpsList={roles} />
  );
};
